import * as yup from 'yup';

const batchEditionCommon = yup.object().shape({
  products: yup.array().of(yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  })).nullable().required('common.required'),
  start: yup.date().nullable().required('common.required'),
  end: yup.date().nullable().required('common.required'),
});

export default batchEditionCommon;
